"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DocumentHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ReviewedDocumentContext = require("../../context/ReviewedDocumentContext");
var _PageContext = require("../../context/PageContext");
var _ChatContext = require("../../context/ChatContext");
var _RulesListContainer = _interopRequireDefault(require("../../components/rules-list/RulesListContainer"));
var _IssueList = _interopRequireDefault(require("@common/components/issues/IssueList"));
var _WordDocumentContext = require("../../context/WordDocumentContext");
var _styledComponents = require("styled-components");
var _filterHeader = require("@common/components/filter-header");
var _AuthContext = require("../../context/AuthContext");
var _liveReviewApply = require("../../utils/live-review-apply");
var _BulkApplyRunContext = require("../../context/BulkApplyRunContext");
var _IssueListHeader = _interopRequireDefault(require("@common/components/review/IssueListHeader"));
var _DeviationScoreBar = _interopRequireDefault(require("@common/components/review/DeviationScoreBar"));
var _PlaybookInfoContainer = _interopRequireDefault(require("../../components/PlaybookInfoContainer"));
var _Spinner = _interopRequireDefault(require("../../components/common/Spinner"));
var _rules = require("../../utils/rules");
var _normalizeIssue = require("@common/utils/normalizeIssue");
var _bulkApplyScope = require("./bulk-apply-scope");
var _deviationSegmentFilter = require("./deviationSegmentFilter");
var _useReportGeneratedRedlines = require("../../hooks/use-report-generated-redlines");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var COMPLIANCE_FILTER_OPTIONS = [{
  label: "Compliant",
  value: "unmatched"
}, {
  label: "Non-compliant",
  value: "matched"
}];
var RISK_SCORE_FILTER_OPTIONS = [{
  label: "High",
  value: "High"
}, {
  label: "Medium",
  value: "Medium"
}, {
  label: "Low",
  value: "Low"
}];
var DocumentHeader = exports.DocumentHeader = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 8px;\n"])));
var HeaderContent = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n"])));
var PlaybookHeader = _styledComponents.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  justify-content: space-between;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n"])));
var PlaybookSection = _styledComponents.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  min-width: 0;\n"])));
var DocumentReviewContainer = _styledComponents.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  opacity: 1;\n"])));
var ContentContainer = _styledComponents.styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-top: 16px;\n  padding-bottom: 16px;\n  gap: 8px;\n"])));
var ScrollWrapper = _styledComponents.styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n"])));
var ScrollContent = _styledComponents.styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var CollapsedHeader = _styledComponents.styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n  padding: ", ";\n  display: ", ";\n  transition: none;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n"])), function (props) {
  return props.$isVisible ? "8px 16px" : "0";
}, function (props) {
  return props.$isVisible ? "block" : "none";
});
var CollapsedPlaybookHeader = (0, _styledComponents.styled)(PlaybookHeader)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  padding: 8px 0;\n"])));
var StickySearchBar = _styledComponents.styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 11; /* Higher than CollapsedHeader */\n  background: white;\n  display: ", ";\n  transition: none;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n"])), function (props) {
  return props.$isVisible ? "block" : "none";
});

// MUST use position: absolute (not display: none): display:none causes layout shifts → flickering.
// Move off-screen and collapse dimensions when hidden so it can't block clicks.
var OriginalHeaderWrapper = _styledComponents.styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  max-height: ", ";\n  overflow: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  visibility: ", ";\n  z-index: ", ";\n  transition: none;\n"])), function (props) {
  return props.$isVisible ? "static" : "absolute";
}, function (props) {
  return props.$isVisible ? "auto" : "-9999px";
}, function (props) {
  return props.$isVisible ? "auto" : "-9999px";
}, function (props) {
  return props.$isVisible ? "auto" : "0";
}, function (props) {
  return props.$isVisible ? "none" : "0";
}, function (props) {
  return props.$isVisible ? "visible" : "hidden";
}, function (props) {
  return props.$isVisible ? "1" : "0";
}, function (props) {
  return props.$isVisible ? "auto" : "none";
}, function (props) {
  return props.$isVisible ? "visible" : "hidden";
}, function (props) {
  return props.$isVisible ? "auto" : "-1";
});
var DocumentReviewPage = function DocumentReviewPage(_ref) {
  var isVisible = _ref.isVisible;
  var areFiltersActive = function areFiltersActive() {
    return searchQuery.trim() !== "" || matchFilter.length > 0 || importanceFilter.length > 0;
  };
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    reviewReport = _useReviewedDocument.reviewReport,
    currentReviewId = _useReviewedDocument.currentReviewId,
    setSelectedRuleUuid = _useReviewedDocument.setSelectedRuleUuid,
    ruleSectionOrder = _useReviewedDocument.ruleSectionOrder,
    ruleSectionOrderKey = _useReviewedDocument.ruleSectionOrderKey,
    setRuleSectionOrder = _useReviewedDocument.setRuleSectionOrder,
    isReportDone = _useReviewedDocument.isReportDone,
    bookmarkToParaIndex = _useReviewedDocument.bookmarkToParaIndex,
    validationMessage = _useReviewedDocument.validationMessage,
    reviewSummaries = _useReviewedDocument.reviewSummaries,
    applyActiveReview = _useReviewedDocument.applyActiveReview;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var _useChat = (0, _ChatContext.useChat)(),
    pendingScrollTarget = _useChat.pendingScrollTarget;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    setDisableRuleRedirect = _useWordDocument.setDisableRuleRedirect;
  var isPageVisible = (0, _react.useRef)(isVisible);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    matchFilter = _useState4[0],
    setMatchFilter = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    importanceFilter = _useState6[0],
    setImportanceFilter = _useState6[1];
  var _useState7 = (0, _react.useState)(new Set()),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedRuleUuids = _useState8[0],
    setSelectedRuleUuids = _useState8[1];
  var bulkApplyRun = (0, _BulkApplyRunContext.useBulkApplyRun)();
  var _useState9 = (0, _react.useState)(new Set()),
    _useState0 = _slicedToArray(_useState9, 2),
    bulkAppliedReviewIds = _useState0[0],
    setBulkAppliedReviewIds = _useState0[1];
  var authHeader = (0, _AuthContext.useAuthHeader)();
  /** The run lives in the app-root provider, so this survives this page's re-renders. */
  var isBulkApplying = bulkApplyRun.isRunning;
  /** Rule clicks stay put while a run is writing into the document; released when the run settles. */
  (0, _react.useEffect)(function () {
    setDisableRuleRedirect(isBulkApplying);
  }, [isBulkApplying, setDisableRuleRedirect]);
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isScrolled = _useState10[0],
    setIsScrolled = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSearchExpanded = _useState12[0],
    setIsSearchExpanded = _useState12[1];
  var scrollContainerRef = (0, _react.useRef)(null);
  var hasBulkApplied = !!currentReviewId && bulkAppliedReviewIds.has(currentReviewId);
  var reportedRedlineIds = (0, _react.useMemo)(function () {
    return isReportDone && currentReviewId && reviewReport ? (0, _useReportGeneratedRedlines.listReviewReportRedlineIds)({
      reviewId: currentReviewId,
      reviewReport: reviewReport
    }) : [];
  }, [currentReviewId, isReportDone, reviewReport]);
  (0, _useReportGeneratedRedlines.useReportGeneratedRedlines)({
    initiatedFrom: "bulk",
    reviewId: currentReviewId,
    redlineIds: reportedRedlineIds
  });

  // Compute document order for each rule once per review/rule-set using the
  // bookmark→paragraph-index map from report.json outline (no Word API needed).
  (0, _react.useEffect)(function () {
    if (!isReportDone) return;
    if (!reviewReport || reviewReport.length === 0) return;
    if (!bookmarkToParaIndex) return; // wait until outline is loaded with the report

    var ruleUuids = reviewReport.map(function (r) {
      var _r$rule;
      return r === null || r === void 0 || (_r$rule = r.rule) === null || _r$rule === void 0 ? void 0 : _r$rule.uuid;
    }).filter(Boolean);
    // Compute orderKey before any early returns so we can mark ordering complete.
    var orderKey = "".concat(currentReviewId !== null && currentReviewId !== void 0 ? currentReviewId : "no-review", ":").concat(ruleUuids.join("|"));
    if (ruleSectionOrderKey === orderKey) return;
    if (ruleUuids.length === 0) {
      setRuleSectionOrder({}, orderKey);
      return;
    }
    var orderByRuleUuid = {};
    var _iterator = _createForOfIteratorHelper(reviewReport),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _item$rule;
        var item = _step.value;
        var ruleUuid = item === null || item === void 0 || (_item$rule = item.rule) === null || _item$rule === void 0 ? void 0 : _item$rule.uuid;
        if (!ruleUuid) continue;
        var bms = (0, _rules.extractRuleBookmarkNames)(item);
        var minPos = Number.MAX_SAFE_INTEGER;
        var _iterator2 = _createForOfIteratorHelper(bms),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var bm = _step2.value;
            var idx = bookmarkToParaIndex.get(bm);
            if (typeof idx === "number" && idx < minPos) minPos = idx;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        orderByRuleUuid[ruleUuid] = minPos;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setRuleSectionOrder(orderByRuleUuid, orderKey);
  }, [currentReviewId, reviewReport, ruleSectionOrderKey, isReportDone, bookmarkToParaIndex]);
  (0, _react.useEffect)(function () {
    isPageVisible.current = isVisible;
  }, [isVisible]);
  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var container = scrollContainerRef.current;
      if (!container) return;
      var scrollTop = container.scrollTop;
      var SCROLL_THRESHOLD = 50;
      var shouldBeScrolled = scrollTop > SCROLL_THRESHOLD;

      // While search is expanded, keep isScrolled pinned so the search input isn't unmounted mid-typing.
      if (isSearchExpanded && !shouldBeScrolled) {
        return;
      }
      if (shouldBeScrolled !== isScrolled) {
        setIsScrolled(shouldBeScrolled);
      }
    };
    var container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return function () {
        return container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isScrolled, isSearchExpanded]);
  (0, _react.useEffect)(function () {
    if (!isSearchExpanded) {
      var container = scrollContainerRef.current;
      if (container) {
        var scrollTop = container.scrollTop;
        var SCROLL_THRESHOLD = 50;
        var shouldBeScrolled = scrollTop > SCROLL_THRESHOLD;
        if (shouldBeScrolled !== isScrolled) {
          setIsScrolled(shouldBeScrolled);
        }
      }
    }
  }, [isSearchExpanded, isScrolled]);
  var handleBulkApply = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var requestedReviewId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!currentReviewId || !authHeader)) {
              _context.n = 1;
              break;
            }
            console.error("Review ID or auth header not available.");
            return _context.a(2);
          case 1:
            requestedReviewId = currentReviewId;
            bulkApplyRun.startRun({
              initiatedFrom: "bulk",
              reviewId: requestedReviewId,
              rules: bulkApplyRequest,
              source: (0, _liveReviewApply.reviewBulkApplySource)(authHeader, requestedReviewId, normalizedIssues, bulkApplyRequest.map(function (rule) {
                return rule.ruleId;
              })),
              /** The review reads as bulk-applied only once its run settled with every rule credited. */
              onComplete: function onComplete(outcome) {
                if (bulkApplyRequest.every(function (rule) {
                  return outcome.creditedRuleIds.includes(rule.ruleId);
                })) {
                  setBulkAppliedReviewIds(function (previous) {
                    return new Set(previous).add(requestedReviewId);
                  });
                }
              }
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleBulkApply() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRuleSelectionChange = function handleRuleSelectionChange(ruleUuid, isSelected) {
    setSelectedRuleUuids(function (prev) {
      var newSet = new Set(prev);
      if (isSelected) {
        newSet.add(ruleUuid);
      } else {
        newSet.delete(ruleUuid);
      }
      return newSet;
    });
  };
  var handleRiskSegmentClick = function handleRiskSegmentClick(riskLevel) {
    if (riskLevel === "compliant") {
      if (matchFilter.includes("unmatched") && matchFilter.length === 1) {
        setMatchFilter([]);
        setImportanceFilter([]);
      } else {
        setMatchFilter(["unmatched"]);
        setImportanceFilter([]);
      }
    } else {
      if (matchFilter.includes("matched") && importanceFilter.includes(riskLevel) && importanceFilter.length === 1) {
        setMatchFilter([]);
        setImportanceFilter([]);
      } else {
        setMatchFilter(["matched"]);
        setImportanceFilter([riskLevel]);
      }
    }
  };
  var activeRiskSegment = (0, _deviationSegmentFilter.activeDeviationSegment)(matchFilter, importanceFilter);
  var normalizedIssues = (0, _react.useMemo)(function () {
    return (0, _normalizeIssue.reviewReportToNormalizedIssues)(reviewReport);
  }, [reviewReport]);
  var TERMINAL_STAGES = new Set(["done", "remedy", "error", "skipped"]);

  // If the user arrived from chat (via the agent's "View review report"
  // button), go back there — ChatPage will scroll to the message they left
  // from and clear the pending target. Otherwise keep the default.
  var handleBack = function handleBack() {
    return showPage(pendingScrollTarget ? _PageContext.PAGES.chatPage : _PageContext.PAGES.submitDocumentPage);
  };
  var handleReviewSelect = function handleReviewSelect(reviewId) {
    applyActiveReview(reviewId);
  };
  var expandedDescriptionSlot = reviewReport ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookInfoContainer.default, {
    riskScoreBar: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeviationScoreBar.default, {
      issues: normalizedIssues,
      onSegmentClick: handleRiskSegmentClick,
      isCollapsed: false,
      activeSegment: activeRiskSegment
    })
  }) : undefined;
  var filteredRules = (0, _react.useMemo)(function () {
    return normalizedIssues.filter(function (issue) {
      if (!(0, _foldedTextSearch.matchesSearch)(issue.name, searchQuery)) {
        return false;
      }
      if (matchFilter.length > 0) {
        var matchValue = issue.match ? "matched" : "unmatched";
        if (!matchFilter.includes(matchValue)) return false;
      }
      if (importanceFilter.length > 0 && !importanceFilter.includes(issue.importance)) {
        return false;
      }
      return true;
    }).sort((0, _rules.makeRuleDocumentOrderComparator)(ruleSectionOrder, function (r) {
      var _r$ruleUuid;
      return (_r$ruleUuid = r.ruleUuid) !== null && _r$ruleUuid !== void 0 ? _r$ruleUuid : "";
    }, function (r) {
      var _r$index;
      return (_r$index = r.index) !== null && _r$index !== void 0 ? _r$index : Number.MAX_SAFE_INTEGER;
    }, function (r) {
      return r.name;
    }));
  }, [normalizedIssues, searchQuery, matchFilter, importanceFilter, ruleSectionOrder]);
  var bulkApplyCandidates = (0, _react.useMemo)(function () {
    if (areFiltersActive() && filteredRules.length === 0) return [];
    return filteredRules.filter(function (r) {
      return !r.conceded && !r.responded;
    });
  }, [filteredRules, searchQuery, matchFilter, importanceFilter]);
  var bulkApplyRequest = (0, _bulkApplyScope.selectBulkApplyRules)(bulkApplyCandidates);
  var hasIssues = bulkApplyRequest.length > 0;
  var allIssuesFinished = hasIssues && bulkApplyCandidates.every(function (i) {
    return TERMINAL_STAGES.has(i.stage);
  });
  var issueFilterSections = [{
    title: "Compliance",
    options: COMPLIANCE_FILTER_OPTIONS,
    selectedValues: matchFilter,
    onSelectedValuesChange: setMatchFilter
  }, {
    title: "Risk score",
    options: RISK_SCORE_FILTER_OPTIONS,
    selectedValues: importanceFilter,
    onSelectedValuesChange: setImportanceFilter
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollWrapper, {
    ref: scrollContainerRef,
    "data-sentry-element": "ScrollWrapper",
    "data-sentry-component": "DocumentReviewPage",
    "data-sentry-source-file": "index.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ScrollContent, {
      "data-sentry-element": "ScrollContent",
      "data-sentry-source-file": "index.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StickySearchBar, {
        $isVisible: isScrolled && isSearchExpanded,
        "data-sentry-element": "StickySearchBar",
        "data-sentry-source-file": "index.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterHeader.FilterHeader, {
          searchQuery: searchQuery,
          onSearchQueryChange: setSearchQuery,
          searchPlaceholder: "Search issues\u2026",
          filterSections: issueFilterSections,
          onClose: function onClose() {
            return setIsSearchExpanded(false);
          },
          "data-sentry-element": "FilterHeader",
          "data-sentry-source-file": "index.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(CollapsedHeader, {
        $isVisible: isScrolled && !isSearchExpanded,
        "data-sentry-element": "CollapsedHeader",
        "data-sentry-source-file": "index.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CollapsedPlaybookHeader, {
          "data-sentry-element": "CollapsedPlaybookHeader",
          "data-sentry-source-file": "index.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueListHeader.default, {
            reviews: reviewSummaries,
            currentReviewId: currentReviewId,
            onReviewSelect: handleReviewSelect,
            isReportDone: isReportDone,
            hasIssues: hasIssues,
            allIssuesFinished: allIssuesFinished,
            onBulkApply: handleBulkApply,
            isBulkApplying: isBulkApplying,
            hasBulkApplied: hasBulkApplied,
            showSearch: true,
            isSearchExpanded: isSearchExpanded,
            onSearchToggle: function onSearchToggle() {
              return setIsSearchExpanded(true);
            },
            onBack: handleBack,
            showDescription: false,
            isCollapsed: false,
            "data-sentry-element": "IssueListHeader",
            "data-sentry-source-file": "index.tsx"
          })
        }), reviewReport && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeviationScoreBar.default, {
          issues: normalizedIssues,
          onSegmentClick: handleRiskSegmentClick,
          isCollapsed: true,
          activeSegment: activeRiskSegment
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(DocumentReviewContainer, {
        "data-sentry-element": "DocumentReviewContainer",
        "data-sentry-source-file": "index.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(OriginalHeaderWrapper, {
          $isVisible: !isScrolled,
          "data-sentry-element": "OriginalHeaderWrapper",
          "data-sentry-source-file": "index.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterHeader.FilterHeader, {
            searchQuery: searchQuery,
            onSearchQueryChange: setSearchQuery,
            searchPlaceholder: "Search issues\u2026",
            filterSections: issueFilterSections,
            "data-sentry-element": "FilterHeader",
            "data-sentry-source-file": "index.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RulesListContainer.default, {
          "data-sentry-element": "RulesListContainer",
          "data-sentry-source-file": "index.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentContainer, {
            "data-sentry-element": "ContentContainer",
            "data-sentry-source-file": "index.tsx",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DocumentHeader, {
              "data-sentry-element": "DocumentHeader",
              "data-sentry-source-file": "index.tsx",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(HeaderContent, {
                "data-sentry-element": "HeaderContent",
                "data-sentry-source-file": "index.tsx",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaybookSection, {
                  "data-sentry-element": "PlaybookSection",
                  "data-sentry-source-file": "index.tsx",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(OriginalHeaderWrapper, {
                    $isVisible: !isScrolled,
                    "data-sentry-element": "OriginalHeaderWrapper",
                    "data-sentry-source-file": "index.tsx",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueListHeader.default, {
                      reviews: reviewSummaries,
                      currentReviewId: currentReviewId,
                      onReviewSelect: handleReviewSelect,
                      isReportDone: isReportDone,
                      hasIssues: hasIssues,
                      allIssuesFinished: allIssuesFinished,
                      onBulkApply: handleBulkApply,
                      isBulkApplying: isBulkApplying,
                      hasBulkApplied: hasBulkApplied,
                      onBack: handleBack,
                      showDescription: true,
                      descriptionSlot: expandedDescriptionSlot,
                      "data-sentry-element": "IssueListHeader",
                      "data-sentry-source-file": "index.tsx"
                    })
                  })
                })
              })
            }), isReportDone && (!reviewReport || reviewReport.length === 0) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "40px 16px",
                textAlign: "center"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: 13,
                  color: "#555",
                  whiteSpace: "pre-line"
                },
                children: (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.trim()) || "No rules to review."
              })
            }) : isReportDone && ruleSectionOrder === null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "40px 0"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
                size: 24
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: 12,
                  color: "#888"
                },
                children: "Ordering by document position\u2026"
              })]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueList.default, {
              items: filteredRules,
              onItemClick: function onItemClick(index) {
                var _filteredRules$index$;
                setSelectedRuleUuid((_filteredRules$index$ = filteredRules[index].ruleUuid) !== null && _filteredRules$index$ !== void 0 ? _filteredRules$index$ : null);
                showPage(_PageContext.PAGES.ruleDetailsPage);
              },
              showCheckbox: false,
              selectedRuleUuids: selectedRuleUuids,
              onRuleSelectionChange: handleRuleSelectionChange
            })]
          })
        })]
      })]
    })
  });
};
var _default = exports.default = DocumentReviewPage;